import { useLazyQuery, useQuery } from "@apollo/react-hooks";
import { loadStripe } from "@stripe/stripe-js";
import { Button, Col, Row, Typography } from "antd";
import * as moment from "moment";
import React, { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router";
import PaymentImage from "../../../../../Assets/Images/006.jpg";
import PaymentMethods from "../../../../../Assets/Images/paymentCompanies.png";
import { Loader } from "../../../../../Components/Loader";
import { SuccessPaymentModal } from "../../../../../Components/Modals/SuccessPaymentModal";
import { CustIcon } from "../../../../../Components/Svgs";
import {
  CREATE_CHECKOUT_SESSION,
  GET_BUSINESS_BY_OWNER,
} from "../../../../../Graphql/queries";

const { Title } = Typography;

export const ReviewPayment = () => {
  const { state: stateParams, search } = useLocation();
  const history = useHistory();
  const [showSuccessModal, setShowSuccessModal] = useState(false);

  const { data: businessData, loading: businessDataLoading } = useQuery(
    GET_BUSINESS_BY_OWNER,
    {
      variables: {
        owner_id: localStorage.getItem("user_id"),
      },
      fetchPolicy: "cache-and-network",
      context: {
        headers: {
          subscription: 1,
        },
      },
    }
  );
  useEffect(() => {
    if (!stateParams && !search) {
      history.push("/on-boarding/payment-plan");
    }
  }, []);

  const handlePaymentRequest = async () => {
    // const handlePaymentRequest = async ({ create_checkout_session }) => {
    // const stripe = await loadStripe(stateParams.publishableKey);
    // stripe.redirectToCheckout({
    //   sessionId: create_checkout_session.session_id,
    // });
    history.push({
      pathname: "/on-boarding/stripe-payment",
      state: {
        // sessionId: create_checkout_session.session_id,
        publishablekey: stateParams.publishableKey,
        locations: businessData?.business[0]?.location_count,
        price_id: stateParams?.selectedPackage.stripe_price_id,
      },
    });
  };

  const [
    CREATE_CHECKOUT_SESSION_QUERY,
    { loading: checkoutSessionDataLoading },
  ] = useLazyQuery(CREATE_CHECKOUT_SESSION, {
    fetchPolicy: "cache-and-network",
    variables: {
      locations: businessData?.business[0]?.location_count,
      price_id: stateParams?.selectedPackage.stripe_price_id,
    },
    context: {
      headers: {
        subscription: 1,
      },
    },
    onCompleted: handlePaymentRequest,
  });

  useEffect(() => {
    if (search) {
      let session_id = new URLSearchParams(search).get("session_id");
      let success = new URLSearchParams(search).get("success") === "true";
      if (!!session_id && success) {
        setShowSuccessModal(true);
      }
    }
  }, [search]);
  
  return (
    <div className="rowSec">
      <SuccessPaymentModal visible={showSuccessModal} />
      <div className="colSec onBoardingLeft">
        <img src={PaymentImage} alt="" className="" />
      </div>
      <div className="colSec onBoardingRight">
        {businessDataLoading || !stateParams ? (
          <Loader />
        ) : (
          <div className="makePayment">
            <p className="text-right text-step">Step 5 of 5</p>
            <Title level={2}>
              <CustIcon type="left-arrow" onClick={() => history.goBack()} />
              Review payment plan detail
            </Title>
            <p className="subTitle">
              You will be getting{" "}
              {stateParams.selectedPackage.free_trial_days + 30} days access
              when you pay first time for monthly subscription. First{" "}
              {stateParams.selectedPackage.free_trial_days} days is free trial
              period in which you can choose to cancel/upgrade your subscription
              at any point.
            </p>
            <Row gutter={16}>
              <Col span={24}>
                <div className="mb-5">
                  <Title level={5} className="text-secondary">
                    Billing Detail
                  </Title>
                  <Title level={4} className="text-primary mt-0 pt-1">
                    {businessData?.business[0]?.location_count} Locations x{" "}
                    {stateParams.selectedPackage.price}$/
                    {stateParams.selectedPackage.billing_period}
                  </Title>
                </div>
                <Row className="mb-4">
                  <Col lg={12}>
                    <div className="mb-4">
                      <Title level={5} className="text-secondary">
                        Subscription Date
                      </Title>
                      <Title level={4} className="text-mute mt-0 pt-0">
                        {moment().format("DD MMMM YYYY")}
                      </Title>
                    </div>
                  </Col>
                  <Col lg={12}>
                    <div className="mb-4">
                      <Title level={5} className="text-secondary">
                        Subscription Billed On
                      </Title>
                      <Title level={4} className="mt-0 pt-0">
                        {stateParams.selectedPackage.billing_period ===
                        "Monthly"
                          ? `${moment().format("Do")} of every month`
                          : `${moment()
                              .add(30, "days")
                              .format("Do MMMM")} of every year`}
                      </Title>
                    </div>
                  </Col>
                </Row>
                <div className="mb-5">
                  <img src={PaymentMethods} className="payByImg" alt="" />
                </div>
              </Col>
              <Col span={24}>
                {" "}
                <Button
                  type="primary"
                  shape="round"
                  size="large"
                  htmlType="submit"
                  loading={checkoutSessionDataLoading}
                  onClick={() => handlePaymentRequest()}
                >
                  Pay $
                  {businessData?.business[0]?.location_count *
                    stateParams.selectedPackage.price}{" "}
                  / {stateParams.selectedPackage.billing_period}
                </Button>
              </Col>
            </Row>
          </div>
        )}
      </div>
    </div>
  );
};
